import { FormErrors } from 'redux-form';
import { ClubCategory, ClubWebsite } from '@Models';

const validate = (values: ClubParams): FormErrors<ClubParams> => {
  const errors: FormErrors<ClubParams> = {};

  if (!values.name) {
    errors.name = 'federation.club.form.name.error';
  }

  if (!values.location) {
    errors.location = 'federation.club.form.location.error';
  }

  if (!values.contact) {
    errors.contact = 'federation.club.form.contact.error';
  }

  if (!values.country) {
    errors.country = 'federation.club.form.country.error';
  }

  return errors;
};
export default validate;

export type ClubParams = {
  name: string;
  country: string;
  location: string;
  notes: string | null;
  contact: string | null;
  members: string | null;
  meets: string | null;
  websites: ClubWebsite[];
  categories: ClubCategory[];
};
